export const PATHS = {
  HOME_REDIRECT: '/',
  CHATBOT: '/chatbot',
  DASHBOARD: '/dashboard',
  PRICING: '/pricing',
  SUBSCRIPTION_THANK_YOU: '/subscription-thankyou',
  SETTINGS: '/settings',
  USER_PROFILE: '/user-profile',
  CHANGE_PASSWORD: '/change-password',
  LEAP: '/leap',
  INTEGRATIONS: '/integrations',
  LEADS: '/leads',
  AUTORESPONSE: '/agentknowledge/knowledgebase',
  UPCOMING: '/upcoming',
  GUIDE: '/guide',
  POLICY: '/policy',
  PREVIEW_CHATBOT: '/preview',
  THREE_DOT_LOADER: '/threedot',
  GENERAL_LOADER: '/loader',
  NOT_FOUND: '*',
};

export const SESSION_PATHS = {
  LOGIN: '/login',
  REGISTER: '/register',
  OTP_VERIFICATION: (type) => `/otpverification/${type}`,
  FORGOT_PASSWORD: '/forgotpassword',
  RESET_PASSWORD: '/resetpassword',
  VERIFY_OTP: '/verify-otp',
};
